import { Component, ViewEncapsulation } from '@angular/core';
import Icons from 'src/app/core/enums/icons.enum';
import { Application } from 'src/portaljs/constants/application';
import { MessageType } from 'src/portaljs/constants/message-type';
import { PortalMessagingService } from 'src/app/core/services/portal-messaging.service';
import { Message } from 'src/portaljs/models/message';
import { AppAction } from 'src/portaljs/models/app-action';
import { AuthService } from 'src/app/core/services/auth.service';
import { environment } from 'src/environments/environment';
import { ChannelEvent, ChannelEventType } from 'src/app/core/models/channel-event.model';
import { ChannelService } from 'src/app/core/services/channel.service';
import { PortalStateService } from 'src/app/core/services/portal-state.service';

@Component({
    selector: 'fss-portal-message-sender',
    templateUrl: (environment.production ? '../empty.html' : './message-sender.component.html'),
    styleUrls: [(environment.production ? '../empty.html' : './message-sender.component.scss')],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class MessageSenderComponent {

  public icons = Icons;
  public applications = Application;
  public messageTypes = MessageType;
  public incomingMessages: any = [];
  public outgoingMessages: any = [];
  public selectedValue: string;

  constructor(private messagingService: PortalMessagingService, private authService: AuthService, private channelService: ChannelService, private portalStateService: PortalStateService) {
    if (environment.production) return; 'PORTAL_TEST_CODE'; // eslint-disable-line
  }

  public sendMessage() {
    if (environment.production) return; 'PORTAL_TEST_CODE'; // eslint-disable-line

    let msg, source, destination;
    const msgType = (document.getElementById('message-select') as HTMLInputElement).value;

    if (msgType === 'channel') {
      const eventTypeVal: any = (document.getElementById('channel-event') as HTMLInputElement).value;
      const eventTypeKey: keyof typeof ChannelEventType = eventTypeVal;
      const channelEventType: ChannelEventType = ChannelEventType[eventTypeKey];
      const ev = new ChannelEvent(channelEventType, new Date());
      this.channelService.sendChannelEvent(ev);

    } else {

      if (this.selectedValue === 'appAction' || this.selectedValue === 'createDeepLink' || this.selectedValue === 'login' || this.selectedValue === 'registerMenuItems' || this.selectedValue === 'iframeMetadata') {
        source = (document.getElementById('message-source') as HTMLInputElement).value as Application;
        destination = Application.PORTAL;
      } else {
        source = Application.PORTAL;
        destination = (document.getElementById('message-destination') as HTMLInputElement).value as Application;
      }

      switch(msgType) {
        case MessageType.iframeMetadata: {
          const width = (document.getElementById('iframe-metadata-width') as HTMLInputElement).value;
          const height = (document.getElementById('iframe-metadata-height') as HTMLInputElement).value;
          msg = new Message(this.messagingService.getNextMessageId(), msgType, source, destination, { width: width, height: height });
          break;
        }
        case MessageType.appAction: {
          const route = (document.getElementById('appAction-route') as HTMLInputElement).value;
          const params = (document.getElementById('appAction-params') as HTMLInputElement).value;
          const appActionDestination = (document.getElementById('appAction-destination') as HTMLInputElement).value as Application;
          const action: AppAction = {destination: appActionDestination, route: route, params: params, source: source};
          const pa = this.portalStateService.getSelectableApp(appActionDestination);
          this.portalStateService.setActiveApp(pa, action);
          break;
        }
        case MessageType.registerMenuItems: {
          const menuItems = (document.getElementById('menu-items') as HTMLInputElement).value;
          const jsonMenuItems = JSON.parse(menuItems);
          msg = new Message(this.messagingService.getNextMessageId(), msgType, source, destination, jsonMenuItems);
          break;
        }
        case MessageType.createDeepLink: {
          const route = (document.getElementById('deepLink-route') as HTMLInputElement).value;
          const params = (document.getElementById('deepLink-params') as HTMLInputElement).value;
          const linkAction: AppAction = {
            source: source,
            destination: Application.PORTAL,
            route: route,
            params: params
          };
          msg = new Message(this.messagingService.getNextMessageId(), msgType, source, destination, linkAction);
          break;
        }
        case MessageType.userStateChange: {
          const event = (document.getElementById('userStateChange-event') as HTMLInputElement).value;
          const authCode = (document.getElementById('userStateChange-authCode') as HTMLInputElement).value;
          msg = new Message(this.messagingService.getNextMessageId(), msgType, source, destination, {event: event, authCode: authCode});
          break;
        }
        case MessageType.tenantChange: {
          const appId = (document.getElementById('tenantChange-appId') as HTMLInputElement).value;
          const siteGuid = (document.getElementById('tenantChange-siteGuid') as HTMLInputElement).value;
          const authCode = (document.getElementById('tenantChange-authCode') as HTMLInputElement).value;
          const userState = { appId: (appId === '' ? this.authService.getDistrictAppId() : appId),
                              siteGuid: (siteGuid === '' ? this.authService.getSiteGuid() : siteGuid),
                              authCode: authCode};
          msg = new Message(this.messagingService.getNextMessageId(), msgType, source, destination, userState);
          break;
        }
        case MessageType.login: {
          const continuationState = (document.getElementById('login-continuationState') as HTMLInputElement).value;
          msg = new Message(this.messagingService.getNextMessageId(), msgType, source, destination, continuationState);
          break;
        }
        default:
          msg = new Message(this.messagingService.getNextMessageId(), msgType as MessageType, source, destination, 'message');
      }
      this.messagingService.postMessage(msg);

    }

  }


}
